"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let UcInvoiceLineGroup = class UcInvoiceLineGroup extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "usercontrol",
    };
    beforeCreate() {
    }
    invoice;
    onInvoice(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("invoice");
    }
    group;
    onGroup(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("group");
    }
    editing;
    expenseTypes;
    async $$load_expenseTypes() {
        return this.$fn.fetch('list_object_by_type', { parameters: { object_type: 'expense-type' } });
    }
    ux;
    dataMembers = ['editing', 'expenseTypes', 'ux'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                editing: false,
                expenseTypes: null,
                ux: null,
            },
        };
    }
    async act_4280711203779102_emit_7194_getActionArgs($event) {
        return {
            event: "reload",
        };
    }
    async evh_4280711203779102_close_7193_getWhen($event) {
        return !!$event.data.modalResult.value;
    }
    async act_4280711203779102_showModal_7192_getActionArgs($event) {
        return {
            name: "InvoiceLineGroup",
            props: {
                invoice: this.invoice,
                groupId: this.group.data.id || null,
                isDefaultGroup: !this.group.data.id,
            },
        };
    }
    async evh_4280711203779102_clickPreventStop(event, scope) {
        return await this.actions.evh_4280711203779102_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_4280711203779102_emit_7194 = new core_1.actions.EmitAction({
            actionArgs: this.act_4280711203779102_emit_7194_getActionArgs,
            events: [],
        });
        const evh_4280711203779102_close_7193 = new core_1.actions.EventHandlerImpl({
            action: act_4280711203779102_emit_7194,
            event: "close",
            when: this.evh_4280711203779102_close_7193_getWhen,
            displayName: "emit",
        });
        const act_4280711203779102_showModal_7192 = new core_1.actions.ShowModalAction({
            actionArgs: this.act_4280711203779102_showModal_7192_getActionArgs,
            events: [evh_4280711203779102_close_7193],
        });
        const evh_4280711203779102_clickPreventStop_7191 = new core_1.actions.EventHandlerImpl({
            action: act_4280711203779102_showModal_7192,
            event: "click.prevent.stop",
            displayName: "showModal",
        });
        const evh_4280711203779102_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_4280711203779102_clickPreventStop_7191],
        });
        return {
            act_4280711203779102_emit_7194,
            evh_4280711203779102_close_7193,
            act_4280711203779102_showModal_7192,
            evh_4280711203779102_clickPreventStop_7191,
            evh_4280711203779102_clickPreventStop,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceLineGroup.prototype, "invoice", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('invoice'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceLineGroup.prototype, "onInvoice", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], UcInvoiceLineGroup.prototype, "group", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('group'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], UcInvoiceLineGroup.prototype, "onGroup", null);
UcInvoiceLineGroup = __decorate([
    (0, vue_property_decorator_1.Component)()
], UcInvoiceLineGroup);
exports.default = UcInvoiceLineGroup;
vue_property_decorator_1.Vue.component("UcInvoiceLineGroup", UcInvoiceLineGroup);
